import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { pipe, Option } from 'effect';

import { payCategoriesListSelector } from '@/domain/payCategories';
import { findCatById } from '@/domain/payCategories/helpers';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PaymentFlowStates from '@/pages/dokkaPay/pages/company/components/PaymentsWorkspace/components/Workspace/components/PaymentFlowStates';
import PaymentsGrid from '@/pages/dokkaPay/pages/company/components/PaymentsWorkspace/components/Workspace/components/Grid';

const Workspace = () => {
  const { formatMessage } = useIntl();
  const { category1 } = useParams();
  const categories = useSelector(payCategoriesListSelector);
  const [showGrid, setShowGrid] = useState(false);

  const title = pipe(
    Option.fromNullable(category1),
    Option.flatMap((id) => Option.fromNullable(findCatById(categories, id))),
    Option.map((category) =>
      formatMessage({ id: `category.name.${category.get('nameId')}`, defaultMessage: category.get('displayName') }),
    ),
    Option.getOrElse(() =>
      category1 ? '' : formatMessage({ id: 'paymentWorkspace.header.title', defaultMessage: 'Payment process' }),
    ),
  );

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          height: 44,
          px: 3,
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'common.white',
        }}
      >
        <Typography variant="subtitle1" fontWeight={500} noWrap>
          {title}
        </Typography>
      </Box>
      <PaymentFlowStates setShowGrid={setShowGrid} />
      {showGrid && <PaymentsGrid />}
    </Box>
  );
};

export default Workspace;
